export default __webpack_public_path__ + "static/FORSINT-RoundLogo-ec96347d4ce9944563c57710517b63cf.svg";